import type { Board } from "./contracts";
import { cacheFor, loadBoard } from "./state";
import { request } from "./transport";
import { newIdempotencyKey } from "./transport";

export async function listRevisions(boardId: string): Promise<unknown[]> {
  return (
    await request<{ items: unknown[] }>("GET", `/api/v1/boards/${boardId}/revisions`)
  ).body.items;
}

export async function restoreRevision(boardId: string, revisionId: string) {
  const cache = cacheFor(boardId);
  if (!cache) throw new Error("Board is not loaded");
  await request<Board>(
    "POST",
    `/api/v1/boards/${boardId}/revisions/${revisionId}/restore`,
    undefined,
    { etag: cache.boardEtag, idempotencyKey: newIdempotencyKey() },
  );
  return loadBoard(boardId);
}
